import TempEntry from 'components_v2/_entryPoints/TempEntry'
import React, { Suspense } from 'react'

const SignIn = React.lazy(() => import('components_v2/SignIn/AloAccess/SignIn'))

export const SignInNewTempEntry = ({ user, ...rest }) => {
  let iosHeaders = {}
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('source') === 'iosApp') {
    iosHeaders = JSON.parse(localStorage.getItem('iosHeaders'))
  }

  return (
    <TempEntry
      mt='0px'
      user={user}
      pb='60px'
      controls={{
        footerFlush: {
          mobile: true,
          desktop: true
        }
      }}
      {...rest}
      {...iosHeaders}
    >
      <Suspense fallback=''>
        <SignIn {...rest} {...iosHeaders} />
      </Suspense>
    </TempEntry>
  )
}

export default SignInNewTempEntry
